import { render, staticRenderFns } from "./node-area.vue?vue&type=template&id=30c9b2e2&scoped=true&"
import script from "./node-area.vue?vue&type=script&lang=js&"
export * from "./node-area.vue?vue&type=script&lang=js&"
import style0 from "./node-area.vue?vue&type=style&index=0&id=30c9b2e2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30c9b2e2",
  null
  
)

export default component.exports